import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=89c1bb1c&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=89c1bb1c&scoped=true&lang=css&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c1bb1c",
  null
  
)

export default component.exports